import PagePositionNav from '../../plugins/pagePositionNav.js';

// const pagePositionNav = new PagePositionNav();
PagePositionNav.init({
  addClassName: "-active"
})